<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">

  <div class="job-posts placements agreements margin-top-service-30px top-link">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-right-0px scansstyle">
      <div class="row">
        

        <div class="col-md-12  CycleTest">

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 padding-right-0px">
                      <img class=" margin-left-6px image-width-scans" src="dummy.jpg" >
                    </div>
                    <div class="col-md-4 padding-left-0px">
                      <div class="row row-height-17px margin-left-0px">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px" *ngIf="MasterData">
                          <label class="margin-bottom-0px font-weight-normal color-secondary">{{MasterData.PatientName}} </label>
                        </div>
                      </div>
                      <div class="row row-height-17px margin-left-0px">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px" *ngIf="MasterData">
                          <label class="margin-bottom-0px font-weight-normal font-size-12px">{{MasterData.PatientFormattedRegCode}}</label>
                        </div>
                      </div>
                      
                      <div class="row row-height-17px">
                        <div class="col-md-12" *ngIf="MasterData">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{MasterData.PatientGender}},{{MasterData.PatientAgeY}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4" *ngIf="MasterData">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{MasterData.PatientPhoneNumber}}</label>
                        </div>
                      </div>

                      

                    </div>
                    <div class="col-md-7  padding-right-0px">

                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Refund # </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="MasterData">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{MasterData.RefundRequestCode}}</label>
                        </div>
                      </div>
                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Bill No </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="MasterData">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px color-Assign">{{MasterData.BillNo}}</label>
                        </div>
                      </div>
                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px"> Date </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="MasterData">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{MasterData.RefundRequestDate| date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                      <!--<div class="row">
    <div class="col-md-1 margin-left-auto padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
      </div>
    <div class="col-md-1 padding-left-7px">
      <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
    </div>

     <div class="col-md-1 padding-left-7px">

      <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
    </div>

  </div>-->
                      
                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px padding-bottom-0px">

                  <div class="card">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                      <div class="row nav-link-hand margin-right-0px">
                        <div class="col-md-6 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Refund Request Items
                          </label>
                        </div>
                        

                      </div>
                    </div>
                    <div class=" padding-lrt " data-ps-id="dfsfsde">
                      <div class="card-body padding-left-0px padding-top-0px padding-right-0px">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped  table-fixed"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>

                                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                                        Item Particulars
                                      </th>



                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-left-0px">
                                        QTY
                                      </th>
                                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                                        Cost
                                      </th>


                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Total Amount
                                      </th>

                                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                                        Refund Qty
                                      </th>

                                      <th class="padding-top-4px padding-bottom-4px th-sticky padding-right-0px">
                                        Reqst Amount
                                      </th>
                                      <!--<th class="">

                </th>-->
                                      <th class="padding-top-4px padding-bottom-4px th-sticky">
                                        Approval Amount
                                      </th>






                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr *ngFor="let l of ItemsData" (click)="DisplaySelectedItems(l)">


                                      <td class="padding-top-0px padding-bottom-0px">
                                        {{l.ItemDescription}}
                                      </td>
                                      <td class="padding-top-0px padding-bottom-0px">{{l.Quantity}}</td>

                                      <td class="padding-top-0px padding-bottom-0px padding-right-0px">
                                        <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                  [(ngModel)]="l.quantity"
                  maxlength="2" required>-->
                                        <label class="margin-bottom-0px">{{l.ItemTotal}}</label>

                                      </td>
                                      <td class="padding-top-0px padding-bottom-0px text-align-center padding-right-15px padding-left-0px">
                                        {{l.RefundTotal}}
                                      </td>

                                      <td class="padding-top-0px padding-bottom-0px padding-right-0px">

                                        <label class="margin-bottom-0px">{{l.RefundQuantity}}</label>

                                      </td>
                                      <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px padding-right-15px">{{l.RefundTotal}}</td>

                                      <td class="padding-top-0px padding-bottom-0px padding-right-0px">
                                        <input type="number" class="form-control text-align-right td-width-100px" placeholder="" [(ngModel)]="l.RefundApprovedAmount">
                                      </td>



                                    </tr>
                                  </tbody>



                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="accordion" id="accordionExample" *ngIf="DetailsSection">
                          <div class="card margin-bottom-5px">
                            <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                              <div class="row margin-right-0px">
                                <div class="col-md-4">
                                  <h5 class="mb-0 height-24px">
                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                      Refund Request Details
                                    </button>
                                  </h5>
                                </div>
                                <div class="col-md-8 ">
                                  <!--<button class="btn actions-btn-prime float-right font-size-13px">Reject</button>
                                  <button class="btn actions-btn-prime float-right font-size-13px margin-right-5px">Approve</button>-->

                                </div>
                              </div>


                            </div>

                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                              <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                <!--<div class="row font-size-14 margin-top-10">
    <div class="col-md-4 text-align-right padding-left-0px">
      <label class="margin-bottom-0px">Total Amount </label>
    </div>:
    <div class="col-md-7  padding-left-10px my-profile-form">

      <div class="form-group margin-bottom-0px">


        <h4 class="margin-bottom-0px  margin-top-3px">4116</h4>


      </div>


    </div>

  </div>-->
                                <div class="row font-size-14 margin-top-10">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label class="margin-bottom-0px">Requested Amount </label>
                                  </div>:
                                  <div class="col-md-7  padding-left-10px my-profile-form">

                                    <div class="form-group margin-bottom-0px" *ngIf="SelectedItems">
                                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                                      <h4 class=" margin-bottom-0px margin-top-3px">{{SelectedItems.RefundTotal}}</h4>


                                    </div>


                                  </div>

                                </div>


                                <div class="row font-size-14 margin-top-10">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label class="margin-bottom-0px">Approved Amount</label>
                                  </div>:
                                  <div class="col-md-7  padding-left-10px my-profile-form">

                                    <div class="form-group margin-bottom-0px" *ngIf="SelectedItems">
                                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                                      <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">{{SelectedItems.RefundApprovedAmount}}</h4>


                                    </div>


                                  </div>

                                </div>
                                <div class="row font-size-14 margin-top-10">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label class="margin-bottom-0px margin-top-0px">Refund Reason </label>
                                  </div>:
                                  <div class="col-md-7  padding-left-10px my-profile-form">

                                    <div class="form-group margin-bottom-0px" *ngIf="MasterData">
                                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                                      <h4 class="color-Assign margin-bottom-0px font-weight-bold margin-top-3px">{{MasterData.RefundReason}}</h4>


                                    </div>


                                  </div>

                                </div>
                                <div class="row font-size-14 margin-top-10">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label class="margin-bottom-0px margin-top-5px">Comments </label>
                                  </div>
                                  <div class="col-md-4  padding-left-10px my-profile-form">

                                    <div class="form-group margin-bottom-0px">
                                      <!--<CodeTypeValue CodeType="FNSTS"></CodeTypeValue>-->
                                      <!--id="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        [(ngModel)]="CurrentSaveSingleEmbryoGradeInfoRequest.Grade" SelectedValue="CurrentSaveSingleEmbryoGradeInfoRequest.Grade"
        name="CurrentSaveSingleEmbryoGradeInfoRequest.Grade">-->

                                      <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                              [(ngModel)]="Comments"   required minlength="1" maxlength="100"></textarea>


                                    </div>


                                  </div>

                                </div>
                                <div class="row font-size-14 margin-top-10">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label class="margin-bottom-0px">1st Approval </label>
                                  </div>:
                                  <div class="col-md-7  padding-left-10px my-profile-form">

                                    <div class="form-group margin-bottom-0px" *ngIf="MasterData">


                                      <h4 class="margin-bottom-0px  margin-top-3px">{{MasterData.FirstLevelApprovedUser}}</h4>


                                    </div>


                                  </div>

                                </div>
                                <div class="row font-size-14 margin-top-10">
                                  <div class="col-md-4 text-align-right padding-left-0px">
                                    <label class="margin-bottom-0px">2nd Approval </label>
                                  </div>:
                                  <div class="col-md-7  padding-left-10px my-profile-form">

                                    <div class="form-group margin-bottom-0px" *ngIf="MasterData">


                                      <h4 class="margin-bottom-0px  margin-top-3px">{{MasterData.SecondLevelApprovedUser}}</h4>


                                    </div>


                                  </div>

                                </div>
                                <div class="row font-size-14 margin-top-10">
                                  <div class="col-md-5 text-align-right padding-right-0px">
                                    <button class="btn actions-btn-prime float-right font-size-13px">Reject</button>
                                    <button (click)="onSubmitApproval()" class="btn actions-btn-prime float-right font-size-13px margin-right-5px">Approve</button>

                                  </div>
                                  

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row margin-left-auto">
                          <div class="col-md-12 padding-l-0px">

                            <!--<div class="card-header wh-header card-header-bg padding-left-7px padding-top-6px margin-top-10">
        Emergency Contact(Family)


      </div>-->

                           


                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        





      </div>
    </div>

  </div>

  
  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
